import Card from '@/components/Card/card.example';

export default Card;
